// removed by extract-text-webpack-plugin
module.exports = {"Input":"src-components-search----input-module---Input---1b17Y","Input__field":"src-components-search----input-module---Input__field---2JivW","Input__icon":"src-components-search----input-module---Input__icon---1klbJ","Input__control":"src-components-search----input-module---Input__control---1T0Is","Input--large":"src-components-search----input-module---Input--large---1aTPK","Input--small":"src-components-search----input-module---Input--small---2R7ad","spinAround":"src-components-search----input-module---spinAround---10QVz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/search/input.module.scss
// module id = 110
// module chunks = 114276838955818 131683993344931 142807904292071